/**
 * Project: Gus's Auto Dealership
 * Author: Eihab Khudhair
 * Description: API client for backend communication
 */

import axios from 'axios';

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Auth API
export const authApi = {
  login: (username: string, password: string) =>
    api.post('/auth/login', { username, password }),
  getProfile: () => api.get('/auth/me'),
};

// Cars API
export const carsApi = {
  getAll: (params?: any) => api.get('/cars', { params }),
  getOne: (id: number) => api.get(`/cars/${id}`),

  create: (data: FormData) =>
    api.post('/cars', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  /**
   * JSON-only update (NO media upload)
   * Use for toggles + edits when files are NOT included
   */
  updateJson: (id: number, payload: any) => api.patch(`/cars/${id}`, payload),

  /**
   * Multipart update (WITH media upload)
   * Use for edits when files ARE included
   */
  updateWithFiles: (id: number, data: FormData) =>
    api.patch(`/cars/${id}/media`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  delete: (id: number) => api.delete(`/cars/${id}`),

  deleteMedia: (carId: number, mediaId: number) =>
    api.delete(`/cars/${carId}/media/${mediaId}`),

  getAnalytics: () => api.get('/cars/admin/analytics'),
  getContactMessages: () => api.get('/cars/admin/contact-messages'),
  submitContact: (data: any) => api.post('/cars/contact', data),
};
